import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import MiniStoreLayout from "./MiniStoreLayout";
import PageNotFound from "../PageNotFound/PageNotFound";
import MsPromotions from "./MsPromotions";
import MsShop from "./MsShop";
// import MiniStoreThemeProvider from "../../MiniStoreContexts/MiniStoreThemeContext";
import MsTopSelling from "./MsPromotionChildren/MsTopSelling";
import MsNewArrivals from "./MsPromotionChildren/MsNewArrivals";
import MsExclusiveDiscouts from "./MsPromotionChildren/MsExclusiveDiscouts";
import MsLimitedStock from "./MsPromotionChildren/MsLimitedStock";
import MsTrendingNow from "./MsPromotionChildren/MsTrendingNow";
import MsCategory from "./MsShopChildren/MsCategory";
import MsCart from "./MsCart/MsCart";
import MsCheckout from "./MsCheckout";
import PaymentSuccessful from "./PaymentSuccessful";
import MsAllPromotions from "./MsPromotionChildren/MsAllPromotions";

const MiniStoreRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MiniStoreLayout />}>
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<MsPromotions />}>
          <Route index element={<MsAllPromotions />} />
          <Route path="top-selling" element={<MsTopSelling />} />
          <Route path="new-arrivals" element={<MsNewArrivals />} />
          <Route path="exclusive-discounts" element={<MsExclusiveDiscouts />} />
          <Route path="limited-stock" element={<MsLimitedStock />} />
        </Route>
        <Route path="shop" element={<Outlet />}>
          <Route path="" index element={<MsShop />} />

          <Route path=":categorySlug/:id" element={<MsCategory />} />
        </Route>
        <Route path="cart" element={<Outlet />}>
          <Route path="" index element={<MsCart />} />
        </Route>

        <Route path="checkout" element={<Outlet />}>
          <Route path="" index element={<MsCheckout />} />
        </Route>
        <Route path="payment-status" element={<PaymentSuccessful />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default MiniStoreRoutes;
